document.addEventListener('DOMContentLoaded', function () {
  var drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  var cartCountEls = document.querySelectorAll('[data-cart-count]');

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateSubtotal(total_price) {
    var subtotalEl = document.getElementById('CartDrawerSubtotal');
    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(total_price);
    }
  }

  function refreshDrawerItems() {
    fetch('/?section_id=cart-drawer-items')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newItems = doc.getElementById('CartDrawerItems');
        var currentItems = document.getElementById('CartDrawerItems');
        if (newItems && currentItems) {
          currentItems.innerHTML = newItems.innerHTML;
        }
      });
  }

  function updateLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        cartCountEls.forEach(function (el) {
          el.textContent = cart.item_count;
        });
        updateSubtotal(cart.total_price);
        refreshDrawerItems();
      });
  }

  document.querySelectorAll('[data-cart-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openDrawer();
    });
  });

  document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
    btn.addEventListener('click', closeDrawer);
  });

  document.addEventListener('click', function (e) {
    var increaseBtn = e.target.closest('[data-cart-qty-increase]');
    var decreaseBtn = e.target.closest('[data-cart-qty-decrease]');
    var removeBtn = e.target.closest('[data-cart-remove]');

    if (increaseBtn || decreaseBtn) {
      var line = (increaseBtn || decreaseBtn).dataset.line;
      var qtySpan = (increaseBtn || decreaseBtn).closest('.cart-drawer__item-qty').querySelector('span');
      var currentQty = parseInt(qtySpan.textContent, 10);
      var newQty = increaseBtn ? currentQty + 1 : Math.max(0, currentQty - 1);
      updateLine(line, newQty);
    }

    if (removeBtn) {
      updateLine(removeBtn.dataset.line, 0);
    }
  });
});